<main class="outer-container form-outer-container">
  <section class="inner-form-container">
    <h3>
      {{'talent-happy-path.quick-apply.otp-page.otp-header' | translate}}
    </h3>
    <div class="otp-helper-info">
      <p [innerHTML]="'talent-happy-path.quick-apply.otp-page.otp-helper-info' | translate:{ email: '<b>' + (talent.primaryEmail ? talent.primaryEmail : talent.email) + '</b>' }"></p>
    </div>
    <form [formGroup]="oneTimePasswordForm" id="otp-form">
      <mat-form-field class="quick-apply-form-field" aria-label="One Time Password Entry Form.">
      <input matInput
             id="otp-input"
             aria-label="Enter the one time password here."
             formControlName="oneTimePassword"
             placeholder="{{'talent-happy-path.quick-apply.otp-page.otp-code' | translate}}"
             maxlength="6"
             inputmode="numeric"
             pattern="[0-9]{6}"
             autofocus>
        <mat-hint> {{'talent-happy-path.quick-apply.otp-page.otp-resend-helper-info' | translate}} &nbsp; <a class="link" (click)="resendOneTimePasscode()">
          {{'talent-happy-path.quick-apply.otp-page.otp-resend' | translate}}</a> </mat-hint>
        <mat-error>{{getErrorMessage() | translate}} &nbsp; <a class="link" (click)="resendOneTimePasscode()">
          {{'talent-happy-path.quick-apply.otp-page.otp-resend' | translate}}</a>
        </mat-error>
      </mat-form-field>
    </form>
    <div *ngIf="userHasExistingPassword" id="password-link">
      <p>
        <a class="resend-button"
           (click)="navigateToPasswordPage()">{{'talent-happy-path.quick-apply.otp-page.sign-in-with-password' | translate}}</a>
      </p>
    </div>
  </section>

  <section class="button-container double-button-container">
    <button mat-stroked-button
            id="otp-back-button"
            class="double-custom-button back-button-outlined"
            color="secondary"
            (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      {{"talent-happy-path.quick-apply.back" | translate}}
    </button>
    <button mat-flat-button
            id="otp-submit-button"
            class="double-custom-button continue-button"
            color="primary"
            [disabled]="oneTimePasswordForm.controls.oneTimePassword.hasError('required')
            || oneTimePasswordForm.controls.oneTimePassword.hasError('pattern')
            || oneTimePasswordForm.controls.oneTimePassword.hasError('minlength')
            || oneTimePasswordForm.controls.oneTimePassword.hasError('maxlength')
            || passcodeAttempts >= 3"
            (click)="continue(oneTimePasswordForm)">
      <mat-icon>arrow_forward</mat-icon>
      {{"talent-happy-path.quick-apply.continue" | translate}}
    </button>
  </section>
</main>
